import React from 'react';

export default function TenantCard({ count }) {
  return (
    <div style={styles.card}>
      <h3 style={styles.title}>Tenants</h3>
      <p style={styles.value}>{count}</p>
    </div>
  );
}

export const styles = {
  card: {
    padding: '1rem',
    background: '#fff',
    borderRadius: 8,
    boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
    textAlign: 'center'
  },
  title: {
    margin: 0,
    fontSize: '1.1rem',
    color: '#333'
  },
  value: {
    fontSize: '2rem',
    margin: '0.5rem 0',
    color: '#01b22c'
  }
};